// removed by extract-text-webpack-plugin
module.exports = {"whiteColor":"#fff","developerPrimaryColor":"#589e69","professionalPrimaryColor":"#13B9E4","enterprisePrimaryColor":"#eca85a","premiumPrimaryColor":"#FFFFFF59","premiumGradientColor":"transparent linear-gradient(44deg, #5000B7 0%, #21024A 100%) 0% 0% no-repeat padding-box"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.module.scss
// module id = 580
// module chunks = 202923723943889